// src/services/customerService.js
import axios from "../api/axiosInstance";

export const getFinancialData = (customerId) => {
  return axios.get(`/Financial/FinancialData`, {
    params: { customerId },
  });
};

export const getOpenReceivableNotesData = (customerId) => {
  return axios.get(`/Financial/OpenReceivableNoteList`, {
    params: { customerId },
  });
};

export const getUnsettledInvoiceData = (customerId) => {
  return axios.get(`/Financial/UnsetteledInvoiceList`, {
    params: { customerId },
  });
};

export const getNotAnalaysisReceiptData = (customerId) => {
  return axios.get(`/Financial/NotAnalysisReceipts`, {
    params: { customerId },
  });
};

export const requestPayment = (payload) => {
  return axios.post("/payment/request", payload);
};

export const getPaymentTrackingCode = (invoiceId) => {
  return axios.get("/payment/tracking-code", {
    params: { invoiceId },
  });
};





